
import { MapData } from '@/types/map-data';

export const FALLBACK_FOOTER_CONTACT: MapData = {
    "Основные данные": {
      "E-mail": "sales@ormis.ru",
      "Телефон": "+7 (495) 662-73-92,<br/> +7(499) 703-30-28 факс",
      "Регионы": [
        "Московская область",
        "Владимирская область",
        "Ивановская область",
        "Ярославская область",
        "Тверская область",
        "Смоленская область",
        "Калужская область",
        "Костромская область",
        "Тульская область",
        "Рязанская область",
        "Орловская область",
        "Брянская область"
      ],
      "Схема проезда": ""
    },
    "Адрес": {
      "Город": "Москва",
      "Улица": "2-й Вязовский проезд",
      "Дом": "владение 22",
      "Офис": "строение 4",
      "Индекс": "101000",
      "Координаты": {
        "lat": 55.715960,
        "lng": 37.767378
      }
    }
  }
